<script lang="ts">
  import Svg from '$src/js/modules/ui/components/Svg.svelte';
  import type { ParticipantType } from '$src/types/participants';

  import Detail from './Detail.svelte';
  import { ParticipantService } from '$src/js/modules/participants/services/ParticipantService';

  const {
    selectable = false,
    theme,
    onSelect,
  }: {
    selectable: boolean;
    theme: 'yellow' | 'green';
    onSelect?: (participantId: number | null, participantName: string) => void;
  } = $props();

  const participants: ParticipantType[] = $state(window.participants);
  let showNewParticipantForm = $state(false);
  let version = $state(0);
  let loading = $state(false);

  const forceUpdate = () => {
    version += 1;
  };

  const onSave = async (data: ParticipantType) => {
    loading = true;

    if (data.id) {
      const participantIndex = participants.findIndex((p) => p.id === data.id);

      if (participantIndex > -1) {
        const newData = JSON.parse(JSON.stringify(data)) as ParticipantType;

        await new Promise((resolve) => setTimeout(resolve, 600));
        await new ParticipantService().updateParticipant(newData);

        participants[participantIndex] = newData;

        window.participants = JSON.parse(
          JSON.stringify(participants)
        ) as ParticipantType[];

        forceUpdate();
      }

      loading = false;
      return;
    }

    const newParticipant = JSON.parse(JSON.stringify(data)) as ParticipantType;

    await new Promise((resolve) => setTimeout(resolve, 600));
    const createdParticipant = await new ParticipantService().createParticipant(
      newParticipant
    );

    if (!createdParticipant?.id) {
      loading = false;
      return;
    }

    newParticipant.id = createdParticipant.id;
    participants.push(newParticipant);

    window.participants = JSON.parse(
      JSON.stringify(participants)
    ) as ParticipantType[];
    forceUpdate();

    loading = false;
  };

  const onDelete = async (id: number | null) => {
    if (!id) {
      return;
    }

    loading = true;
    const index = participants.findIndex((p) => p.id === id);

    if (index > -1) {
      await new Promise((resolve) => setTimeout(resolve, 300));
      await new ParticipantService().deleteParticipant(id);

      participants.splice(index, 1);
      window.participants = JSON.parse(
        JSON.stringify(participants)
      ) as ParticipantType[];
      forceUpdate();
    }

    loading = false;
  };
</script>

<div class="2xl:fluid-gap-[16] flex flex-col gap-4">
  {#key version}
    {#each participants as participant (participant.id)}
      <Detail
        {theme}
        {selectable}
        participant={JSON.parse(JSON.stringify(participant)) as ParticipantType}
        {loading}
        {onSave}
        {onDelete}
        {onSelect}
      />
    {:else}
      <p class="text-14px">
        Je hebt nog geen deelnemers. Voeg er een toe om nieuwe aanmeldingen voor
        evenementen te vereenvoudigen.
      </p>
    {/each}
  {/key}

  {#if showNewParticipantForm}
    {#key version}
      <Detail
        newParticipant={true}
        onClose={() => (showNewParticipantForm = false)}
        {theme}
        selectable={false}
        {loading}
        {onSave}
        {onDelete}
      />
    {/key}
  {/if}
</div>

<button
  type="button"
  class={`2xl:fluid-mt-[32] mt-8 ${theme === 'green' ? 'btn-green-large' : 'btn-primary-large'}`}
  onclick={() => (showNewParticipantForm = true)}
>
  <Svg
    image="plus-squared"
    width={20}
    height={20}
    className="2xl:fluid-w-[20] 2xl:fluid-h-[20] fill-black-1000 transition"
  />
  <span class="h-[1cap]">Deelnemer toevoegen</span>
</button>
